module.exports = __webpack_public_path__ + "static/media/37_tn.7a27a34f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/37_tn.jpg
// module id = 346
// module chunks = 0